module.exports = __webpack_public_path__ + "img/programme2.8848d8f0.png";